/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._RichTextEditor_6dwyt_48 {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column-reverse;
}
._RichTextEditor_6dwyt_48 .ql-container {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border: 1px solid hsl(var(--border));
  border-top: 1px solid hsl(var(--border)) !important;
}
._RichTextEditor_6dwyt_48 .ql-toolbar {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border: 1px solid hsl(var(--border));
  border-top: none;
}
._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-bold::before, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-bold::after, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-italic::before, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-italic::after, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-underline::before, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-underline::after, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-link::before, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-link::after, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-align::before, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-align::after {
  content: none !important;
  display: none !important;
  background-image: none !important;
}
._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-align[value=""]::before, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-align[value=""]::after, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-align[value=center]::before, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-align[value=center]::after, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-align[value=right]::before, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-align[value=right]::after, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-align[value=justify]::before, ._RichTextEditor_6dwyt_48 .ql-toolbar button.ql-align[value=justify]::after {
  content: none !important;
  display: none !important;
  background-image: none !important;
}
._RichTextEditor_6dwyt_48 .ql-toolbar button svg {
  display: inline-block !important;
  fill: hsl(var(--foreground)) !important;
  width: 16px !important;
  height: 16px !important;
}
._RichTextEditor_6dwyt_48 .ql-editor {
  font-size: 14px !important;
  color: hsl(var(--primary)) !important;
}
._RichTextEditor_6dwyt_48 .ql-editor.ql-blank::before {
  color: hsl(var(--refresh-grey-4)) !important;
  font-style: normal !important;
}